import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddManufacturerModal from "./components/AddManufacturerModal";
import ManufacturerTable from "./components/ManufacturerTable";
import {
  selectManufacturersList,
  selectManufacturersLoading,
} from "./redux/selector";
import { manufacturerSaga } from "./redux/saga";
import { manufacturerActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./style";

const Manufacturer = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const [addModalOpen, setAddModalOpen] = useState(false);

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: manufacturerSaga,
  });

  const rows = useSelector(selectManufacturersList);
  const loading = useSelector(selectManufacturersLoading);

  useEffect(() => {
    dispatch(manufacturerActions.getManufacturersList());
  }, [dispatch]);

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb title={t("SIDEBAR.MANUFACTURERS")} iconPosition="end" />
            <ActionBar onAddClick={() => setAddModalOpen(true)} />
            <ManufacturerTable rows={rows} loading={loading} />
          </Box>
        </Box>
      <AddManufacturerModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
      />
    </Box>
  );
};

export default Manufacturer;
